// src/pages/CreateUser.tsx
import { useState } from 'react';
import axios from 'axios';
import { Form, Button, Container, Alert } from 'react-bootstrap';
import { UserResponse } from '../types/Auth';
import { Navigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL;

function CreateUser() {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [role, setRole] = useState('viewer');
  const [roles, setRoles] = useState<string[]>(["viewer"]);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    try {
      const response = await axios.post<UserResponse>(`${API_URL}/auth/create-user`, {
        username,
        email,
        password,
        role,
        roles
      });
      //setSuccess(`Usuario ${response.data.username} creado con rol ${response.data.role}`);
      setSuccess(`Usuario ${response.data.username} creado con roles: ${response.data.roles.join(", ")}`);
      setUsername('');
      setEmail('');
      setPassword('');
      setRole('viewer');
    } catch (err) {
      setError('Error al crear usuario');
    }
  };

  const user = JSON.parse(localStorage.getItem('user') || '{}');
  //if (user.role !== 'admin') return <Navigate to="/contacts" />;
  if (!user.roles?.includes("admin")) return <Navigate to="/contacts" />;
  
  return (
    <Container className="mt-5" style={{ maxWidth: '500px' }}>
      <h2>Crear Usuario</h2>
      {success && <Alert variant="success">{success}</Alert>}
      {error && <Alert variant="danger">{error}</Alert>}
      <Form onSubmit={handleSubmit}>
        <Form.Group className="mb-3">
          <Form.Label>Usuario</Form.Label>
          <Form.Control value={username} onChange={(e) => setUsername(e.target.value)} required />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Correo</Form.Label>
          <Form.Control type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Contraseña</Form.Label>
          <Form.Control type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </Form.Group>
        <Form.Group className="mb-3">
          <Form.Label>Roles</Form.Label>
          <Form.Select
            multiple
            value={roles}
            onChange={(e) => {
              const selected = Array.from(e.target.selectedOptions, option => option.value);
              setRoles(selected);
            }}
          >
            <option value="admin">Admin</option>
            <option value="viewer">Viewer</option>
            <option value="clusters">Clusters</option>
          </Form.Select>
          <Form.Text className="text-muted">
            Mantén presionado CTRL (Windows) o CMD (Mac) para seleccionar varios.
          </Form.Text>
        </Form.Group>

        <Button type="submit" variant="primary" className="w-100">Crear</Button>
      </Form>
    </Container>
  );
}

export default CreateUser;